$(document).ready(function(){
  
  
	$('.footer-block--menu .footer-block__heading').click(function () {
		if ($(window).width() < 749) {
			$(this).toggleClass('active_item');
			$(this).siblings('.footer-block__details-content').slideToggle();
		} else {
			$(this).siblings('.footer-block__details-content').show();
		}
	});
  // banner image carousel
   $('.banner_image_carousel').owlCarousel({
        center: true,
        items: 4,
        loop: true,
        margin: 5,
        nav: false,
       autoplay: true,
        dots: false,
        responsive: {
          0: {
            items: 1.2
          },
          768: {
            items: 2
          },
          1024: {
            items: 3.5
          }
        }
      });
  
   $('.product-carousel-slide').owlCarousel({ 
        items: 4,
        loop: true,
        margin: 5,
        autoplay: true,
        dots: false,
        nav: true,
        responsive: {
          0: {
            items: 2
          },
          768: {
            items: 3
          }, 
          1024: {
            items: 4
          }
        }
      });

}); 


  document.addEventListener("DOMContentLoaded", function () {
    const counters = document.querySelectorAll(".k_stats-number");

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5
    };

    const animateCounter = (el, target) => {
      let start = 0;
      const duration = 1500;
      const increment = target / (duration / 16);

      const span = el.querySelector(".k_counter");
      const prefix = el.textContent.split(span.textContent)[0];
      const suffix = el.textContent.split(span.textContent)[1];

      const counter = () => {
        start += increment;
        if (start < target) {
          span.innerText = Math.floor(start);
          requestAnimationFrame(counter);
        } else {
          span.innerText = target;
        }
      };
      counter();
    };

    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = parseFloat(el.dataset.target);
          animateCounter(el, target);
          observer.unobserve(el);
        }
      });
    }, options);

    counters.forEach(counter => observer.observe(counter));
  });